import * as yup from 'yup';

import { FormProvider, useForm } from 'react-hook-form';
import React, { useCallback, useState } from 'react';

import {
  Button,
  ButtonSizeEnum,
  ButtonVariantEnum,
} from '../../shared/components/Button';
import { TextInput } from '../../shared/components/TextInput';
import { yupResolver } from '@hookform/resolvers/yup';
import { http } from '../../shared/services/http';
import { useNavigator } from '../../routing/navigator';
import { showPublicToast } from '../../shared/utils/show-public-toast';
import { css } from '@emotion/css';

interface IForgotPasswordForm {
  email: string;
}

const schema = yup.object().shape({
  email: yup.string().email().required('Email is required'),
});

export const ForgotPasswordForm: React.FC = () => {
  const methods = useForm<IForgotPasswordForm>({
    defaultValues: {
      email: '',
    },
    shouldUseNativeValidation: false,
    resolver: yupResolver(schema),
    mode: 'onBlur',
  });
  const navigator = useNavigator();
  const [sending, setSending] = useState(false);

  const onSubmit = useCallback(
    methods.handleSubmit(async (data) => {
      try {
        setSending(true);
        await http.forgotPassword(data);
        showPublicToast('Check your inbox for the reset link.');
        navigator.toEmailSignIn();
      } catch (e) {
        console.error(e);
        showPublicToast(`We couldn't send the email. Please try again.`);
      } finally {
        setSending(false);
      }
    }),
    [],
  );

  return (
    <form onSubmit={onSubmit} className={formStyle}>
      <FormProvider {...methods}>
        <TextInput name="email" placeHolder="Email" type="email" />
        <Button
          variant={ButtonVariantEnum.FILLED}
          size={ButtonSizeEnum.LARGE}
          text="Send me an email"
          type="submit"
          fullWidth
          loading={sending}
        />
      </FormProvider>
    </form>
  );
};

const formStyle = css`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;
